import {
  PERSIST_ANOMALY_RULE,
  PERSIST_FINDING_RULE,
  PERSIST_FILTER_DATA,
  PERSIST_ANOMALY_RULE_FILTER,
  FETCH_ALL_ANOMALY_RULE_SUCCESS,
  FETCH_ALL_ANOMALY_RULE_FAILURE,
  FETCH_All_FINDING_RULE_SUCCESS,
  FETCH_All_FINDING_RULE_FAILURE,
  CLEAR_ANOMALY_RULE_FILTER
} from "../_constants";

const initialState = {
  anomalyRule: "",
  findingRule: "",
  filterData: "",
  anomalyRuleFilter: "",
  allAnomalyRules: "",
  allFindingRules: "",
  error: "",
};
export const detailsPersistReducer = (state = initialState, action) => {
  switch (action.type) {
    case PERSIST_ANOMALY_RULE:
      return {
        ...state,
        anomalyRule: action.payload,
      };
    case PERSIST_ANOMALY_RULE_FILTER:
      return {
        ...state,
        anomalyRuleFilter: action.payload,
      };
      case CLEAR_ANOMALY_RULE_FILTER:
        return {
          ...state,
          anomalyRuleFilter: "",
          filterData: ""
        };
    case PERSIST_FINDING_RULE:
      return {
        ...state,
        findingRule: action.payload,
      };
    case PERSIST_FILTER_DATA:
      return {
        ...state,
        filterData: action.payload,
      };
    case FETCH_ALL_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        allAnomalyRules: action.payload,
        error: "",
      };
    case FETCH_ALL_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        allAnomalyRules: "",
        error: action.payload,
      };
    case FETCH_All_FINDING_RULE_SUCCESS:
      return {
        ...state,
        allFindingRules: action.payload,
        error: "",
      };
    case FETCH_All_FINDING_RULE_FAILURE:
      return {
        ...state,
        allFindingRules: "",
        error: action.payload,
      };
    default:
      return state;
  }
};
